export var AUTHENTICATION_CHECK_EMAIL_TYPE = 'authentication/checkEmail/status_changed';
export var AUTHENTICATION_AUTHENTICATE_TYPE = 'authentication/authenticate/status_changed';
export var AUTHENTICATION_TWO_FACTOR_TYPE = 'authentication/twoFactor/status_changed';
export var AUTHENTICATION_RESTORE_TYPE = 'authentication/restore/status_changed';
export var AUTHENTICATION_CHANGE_VIEW_TYPE = 'authentication/changeView';
export var AUTHENTICATION_CHANGE_PASSWORD_TYPE = 'authentication/changePassword';
export var AUTHENTICATION_RESET_TYPE = 'authentication/reset';